import React, { FunctionComponent } from 'react';
import styles from './FeatureLists.module.scss';
import { Block, BlockContent, Typography } from 'components/elements';
import { WPAcfFeatureLists } from 'types/acf/features';
import DOMPurify from 'dompurify';

interface OwnProps {
  data: WPAcfFeatureLists | null;
}

type FeatureListsProps = JSX.IntrinsicElements['div'] & OwnProps;

const FeatureLists: FunctionComponent<FeatureListsProps> = props => {
  const { data } = props;

  if (!data) {
    return null;
  }

  const { lists, header } = data;

  return (
    <Block id="feature-list" data-module="feature-list" theme="white">
      <BlockContent direction="row" className={styles.container}>
        <Typography mobile="new_neue_semibold_26" tablet="new_neue_semibold_26" desktop="new_neue_32_h1" as="h2" className={styles.header}>
          {header}
        </Typography>
        {lists &&
          lists.length > 0 &&
          lists
            .filter(list => list && list.description)
            .map(({ description }, index) => (
              <Typography
                key={`feature-list-item-${index}`}
                mobile="new_ibm_regular_16"
                tablet="new_ibm_regular_16"
                desktop="new_ibm_regular_16"
                className={styles.description}
                as="div"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description as string) }}
              />
            ))}
      </BlockContent>
    </Block>
  );
};

export default FeatureLists;
